exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".prSelect {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: row;\n        flex-direction: row;\n    width: 100%;\n    white-space: nowrap;\n    -ms-flex-align: center;\n        align-items: center;\n}\n\n.prSelect > .checkboxFilterDeleted {\n    width: 20px;\n    height: 20px;\n    margin-left: 10px;\n}\n\n.prSelect > .lblFilterDeleted {\n    margin-left: 5px;\n}\n", ""]);

// exports
